class BodyScroll {
	constructor(el) {
		this.el = el;
		this.body = document.body;
		this.setHeight();
		window.addEventListener('resize', this.setHeight);
	}
	setHeight = () => {
		this.el.style.height = window.innerHeight + 'px';
		this.body.style.height = window.innerHeight + 'px';
	};
}

const el = document.querySelector('.page--whooping-landing');

if (el) {
    if(window.Modernizr.touch) {
        new BodyScroll(el);
    }
}
